import React from "react";

/**
 * Block progress indicator component
 * Shows current block progress towards target
 */
const BlockProgress = ({ current, target = 5 }) => {
  const percentage = (current / target) * 100;

  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-white font-semibold text-lg">Block Progress</h3>
        <span className="text-white/60 text-sm">
          {current} / {target}
        </span>
      </div>
      <div className="w-full bg-white/10 rounded-full h-3 overflow-hidden">
        <div
          className="bg-gradient-to-r from-purple-500 to-blue-500 h-full rounded-full transition-all duration-300"
          style={{ width: `${Math.min(percentage, 100)}%` }}
        ></div>
      </div>
      <p className="text-white/60 text-xs mt-3">
        {target - current} more {target - current === 1 ? "block" : "blocks"} needed to complete this round
      </p>
    </div>
  );
};

export default BlockProgress;
